
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/maintenance/[id]",
      function () {
        return require("private-next-pages/maintenance/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/maintenance/[id]"])
      });
    }
  